import React from "react";
import { BackIcon } from "../../views/Common/SvgIcons/WorkflowIcons";
import "./PathBreadcrumb.scss";

/**
 * Shared hierarchy path nav: ← Parent / Child / Current
 * items: [{ label, onClick? }] — last item is the active (current) crumb
 */
export default function PathBreadcrumb({
  items = [],
  onBack,
  showBackButton = true,
  className = "",
  "aria-label": ariaLabel = "Breadcrumb",
}) {
  if (!items.length && !(showBackButton && onBack)) return null;

  const crumbs = items.map((item, index) => ({
    ...item,
    active: index === items.length - 1,
  }));

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    const parent = [...crumbs].reverse().find((item) => !item.active && item.onClick);
    parent?.onClick?.();
  };

  return (
    <nav
      className={`path-breadcrumb d-a gap-2 flex-wrap py-2 ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {showBackButton && (
        <button
          type="button"
          className="plain-button2 d-a px-0"
          onClick={handleBack}
          aria-label="Go back"
        >
          <BackIcon className="wf-icon text-secondary" />
        </button>
      )}
      {crumbs.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          {index > 0 && (
            <span className="path-breadcrumb__sep text-secondary">/</span>
          )}
          <button
            type="button"
            className={`path-breadcrumb__item${item.active ? " is-active" : ""}`}
            onClick={item.onClick}
            disabled={item.active || !item.onClick}
          >
            {item.label}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
